import React, { useEffect, useState } from 'react';
import { usePaginacion, Paginacion, PiePagina, uuidv4, Axios } from '../../../Helpers/importacionesComunes'
import { } from '@fortawesome/free-regular-svg-icons';
import { faSort } from '@fortawesome/free-solid-svg-icons';
import { useContextoGlobal } from '../../../Context/contextoGlobal'
import Excel from '../../../componentes/Excel'
import { Card, CardBody,Button, Typography } from '@material-tailwind/react';
import { ChevronUpDownIcon, TrashIcon, EyeIcon, PencilSquareIcon } from '@heroicons/react/24/solid';
import { useHistory } from "react-router-dom";
import { formatearMontoMoneda } from '../../../Helpers/utilidades-globales';
import moment from 'moment';

const columnas = [
    { label: 'Fecha', value: 'fecha' },
    { label: 'Contribuyente', value: 'contribuyente' },
    { label: 'Comprobante', value: 'comprobante'},
    { label: 'Forma Pago', value: 'forma_pago' },
    { label: 'Detalle', value: 'detalle' },
    { label: 'Total', value: 'monto' },
]

// Convierte el monto (número o string con formato "77.000,00") a número para ordenar.
const parseMonto = (v) => {
    if (typeof v === 'number') return v
    if (v == null || v === '') return 0
    let n = Number(v)
    if (!isNaN(n)) return n
    n = Number(String(v).replace(/\./g, '').replace(',', '.').replace(/[^0-9.-]/g, ''))
    return isNaN(n) ? 0 : n
}

export const Tabla = ({ registrosAmostrar, cleanUpData, deleteIngreso, onCrearIngreso }) => {

    const { configuracion, paginar, inicializar: inicializarPaginacion } = usePaginacion()
    // Hago una copia de los datos que se reciben para manejar el ordenamiento
    const [copiaRegistrosaMostrar, setCopiaRegistrosaMostrar] = useState([...registrosAmostrar])
    const [orden, setOrden] = useState(null)
    const [nuevoCampo, setNuevoCampo] = useState(true)
    const [contadorOrden, setContadorOrden] = useState(0)
    const [rubros, setRubros] = useState([]);
    const [proveedores, setProveedores] = useState([]);
    const [formasPago, setFormasPago] = useState([]);
    const { usuario } = useContextoGlobal()
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(!open);
    const history = useHistory();

    useEffect(() => {
        setCopiaRegistrosaMostrar([...registrosAmostrar])
        inicializarPaginacion(null, registrosAmostrar)
    }, [registrosAmostrar])


    useEffect(() => {// el ordenamiento se maneja con las propiedades orden que almacena el campo por el cual ordenar
        // y nuevoCampo que es un flag que indica si es otro campo o el mismo a la inversa
        // cada vez que se cambia el orden en click de la cabecera se cambia contadorOrden como un trigger 

        ordenarDatos()
    }, [contadorOrden])

    const ordenarDatos = () => {
        setCopiaRegistrosaMostrar([...registrosAmostrar.sort((a, b) => { return comparacion(a, b) })
        ])
    }

    const funcionOrden = (nombre_campo) => {

        if (orden == nombre_campo) {
            setNuevoCampo(false)
        } else {
            setNuevoCampo(true)
        }

        setOrden(nombre_campo)
        setContadorOrden(contadorOrden + 1)

    }

    const comparacion = (a, b) => {

        switch (orden) {
            case null: return 0
            case 'id_region':
            case 'edad':

                if (nuevoCampo == true) {
                    return a[orden] - b[orden]
                } else {
                    if (contadorOrden % 2 == 0) {
                        return b[orden] - a[orden]
                    } else {
                        return a[orden] - b[orden]
                    }
                }
            case 'ult_ascenso':
            case 'fecha':

                const dia_a = Number(a[orden].substring(0, 2));
                const mes_a = Number(a[orden].substring(3, 5));
                const anio_a = Number(a[orden].substring(6, 10));

                const fa = new Date(anio_a, mes_a, dia_a);

                const dia_b = Number(b[orden].substring(0, 2));
                const mes_b = Number(b[orden].substring(3, 5));
                const anio_b = Number(b[orden].substring(6, 10));

                const fb = new Date(anio_b, mes_b, dia_b);

                if (nuevoCampo == true) {
                    return fa - fb
                } else {
                    if (contadorOrden % 2 == 0) {
                        return fb - fa
                    } else {
                        return fa - fb
                    }
                }
            case 'monto':
                const montoA = parseMonto(a[orden])
                const montoB = parseMonto(b[orden])
                if (nuevoCampo == true) {
                    return montoA - montoB
                } else {
                    return contadorOrden % 2 == 0 ? montoB - montoA : montoA - montoB
                }
            default:
                if (nuevoCampo == true) {
                    return String(a[orden] ?? '').localeCompare(String(b[orden] ?? ''))
                } else {
                    if (contadorOrden % 2 == 0) {
                        return String(b[orden] ?? '').localeCompare(String(a[orden] ?? ''))
                    } else {
                        return String(a[orden] ?? '').localeCompare(String(b[orden] ?? ''))
                    }
                }
        }
    }

    const convertirFormato = (numero) => {
        let numeroConPunto = numero.replace(/,/g, '.');
        let numeroEnNuevoFormato = numeroConPunto.replace(/\.(?=[^.]*$)/, ',');
        return numeroEnNuevoFormato;
    }

    const truncateText = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.substring(0, maxLength);
        }
        return text;
    };

    const verIngreso = (id_ingreso) => {
        localStorage.setItem('ingresoId', JSON.stringify({ id_ingreso }));
        history.push({
            pathname: '/ingreso/detalle',
        });
    }

    const editarEgreso = (id_ingreso) => {
        localStorage.setItem('editIngresoId', JSON.stringify({ id_ingreso }));
        history.push({
            pathname: '/ingreso/crear-e',
        });
    }

    return <div className="mt-2 mx-5">

        {copiaRegistrosaMostrar.length > 0 && <Excel datos={copiaRegistrosaMostrar}
            descripcion='Movimientos'
            columnas={columnas}
            titulo='Ingresos' />}
        {copiaRegistrosaMostrar.length > 0 && <div className="mb-4" />}
        
        {copiaRegistrosaMostrar.length > 0 &&
            <Card className="h-full w-full rounded-none">
                <CardBody className="overflow-scroll-none px-0 pt-0 pb-0">
                    <table className="table-auto text-left w-full">
                        <thead>
                            <tr>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Fecha' sort orden={orden === 'fecha'} callback={() => funcionOrden('fecha')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Contribuyente' sort orden={orden === 'contribuyente'} callback={() => funcionOrden('contribuyente')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Comprobante' sort orden={orden === 'titular'} callback={() => funcionOrden('comprobante')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50 w-[20%]">
                                    <ThTitle title='Forma Pago' sort orden={orden === 'forma_pago'} callback={() => funcionOrden('forma_pago')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50 w-[20%]">
                                    <ThTitle title='Detalle' sort orden={orden === 'detalle'} callback={() => funcionOrden('detalle')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Total' sort orden={orden === 'monto'} callback={() => funcionOrden('monto')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Acciones' sort orden={orden === 'acciones'} callback={() => {}} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {copiaRegistrosaMostrar.reverse()
                                .filter((item, index) => {
                                    return index >= configuracion.iIni && index <= configuracion.iFin
                                })
                                .map(
                                    (item, index) => {
                                        const isLast = index === copiaRegistrosaMostrar.length - 1;
                                        const classes = isLast
                                            ? "p-4"
                                            : "p-4 border-b border-blue-gray-50";

                                        return (
                                            <>
                                                <tr key={uuidv4()}>
                                                    <td className={classes}>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-normal opacity-70 text-center"
                                                        >
                                                            {moment(item.fecha).format('DD/MM/YYYY')}
                                                        </Typography>
                                                    </td>
                                                    <td className={classes}>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-normal text-left"
                                                        >
                                                            {item.contribuyente ?? '--'}
                                                        </Typography>
                                                    </td>
                                                    <td className={classes}>
                                                        <ComprobanteChip value={item.comprobante} />
                                                    </td>
                                                    <td className={classes}>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-normal text-left"
                                                        >
                                                            {item.forma_pago ?? '--'}
                                                        </Typography>
                                                    </td>
                                                    <td className={classes}>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-normal text-left"
                                                        >
                                                            {item.detalle ?? '--'}
                                                        </Typography>
                                                    </td>
                                                    <td className={classes}>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-normal text-right"
                                                        >
                                                            {formatearMontoMoneda(item.monto)}
                                                        </Typography>
                                                    </td>

                                                    <td className={classes}>
                                                        <div className="flex items-center justify-center gap-2">
                                                            <EyeIcon className="h-4 w-4 text-gray-900 cursor-pointer hidden" onClick={() => verIngreso(item.id_ingreso)} />
                                                            <span
                                                                onClick={() => editarEgreso(item.id_ingreso)}
                                                                title="Editar el ingreso"
                                                                className="cursor-pointer text-blue-gray-500 hover:text-blue-gray-700 transition-colors"
                                                            >
                                                                <PencilSquareIcon className="h-6 w-6" />
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </>

                                        );

                                    }
                                )}
                        </tbody>
                    </table>

                    {copiaRegistrosaMostrar.length > 0 &&
                        <PiePagina>
                            <div className="items-center">
                                <Paginacion configuracion={configuracion} paginar={paginar} />
                            </div>
                        </PiePagina>}
                </CardBody>
            </Card>
        }
    </div>
}


const ThTitle = ({ title, sort, orden, callback }) => {
    return <div className='flex f-col justify-center items-center'>
        <Typography
            variant="small"
            color="blue-gray"
            className="flex justify-between gap-2 font-normal leading-none opacity-70"
        >
            {title}{" "}
            {sort &&
                <ChevronUpDownIcon strokeWidth={2} className={`cursor-pointer ${orden ? 'text-blue-500' : ''} h-4 w-4`} icon={faSort} onClick={callback} />
            }
        </Typography>
    </div>
}

const ComprobanteChip = ({ value }) => {
    const hasValue = Boolean(value);

    return (
        <span
            className={[
                'inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold shadow-sm',
                hasValue
                    ? 'border-cyan-100 bg-cyan-50 text-cyan-700'
                    : 'border-blue-gray-100 bg-blue-gray-50 text-blue-gray-500'
            ].join(' ')}
        >
            {hasValue ? value : '--'}
        </span>
    );
};